import { v4 as uuid } from "uuid";

import { sessionStorage } from "@ctv/shared-core/src";

const VISIT_ID_SESSION_STORAGE_KEY = "$trck$";

export function getVisitId(): [string, number] {
  const visitId = sessionStorage.get(VISIT_ID_SESSION_STORAGE_KEY);

  if (visitId) {
    const eventSeq = Number(
      sessionStorage.get(VISIT_ID_SESSION_STORAGE_KEY + visitId) || 0
    );

    return [visitId, eventSeq];
  }

  const newVisitId = uuid();
  sessionStorage.set(VISIT_ID_SESSION_STORAGE_KEY, newVisitId);
  sessionStorage.set(VISIT_ID_SESSION_STORAGE_KEY + newVisitId, 0);

  return [newVisitId, 0];
}

export function incrementEventSeq(newEventSeq: number) {
  const [visitId] = getVisitId();
  sessionStorage.set(VISIT_ID_SESSION_STORAGE_KEY + visitId, newEventSeq);
}

export function removeVisitId() {
  const visitId = sessionStorage.get(VISIT_ID_SESSION_STORAGE_KEY);

  if (visitId) {
    sessionStorage.remove(VISIT_ID_SESSION_STORAGE_KEY);
    sessionStorage.remove(VISIT_ID_SESSION_STORAGE_KEY + visitId);
  }
}
